import React, { useState } from 'react';

import CLocalizedTextStringStatic from './CLocalizedTextStringStatic';
import CMarkdownText from './CMarkdownText';
import { type IOverlayMessage } from './IOverlayMessage';
import XDFloatIn from './animate/XDFloatIn';

interface Props {
  message: IOverlayMessage;
}

/**
 * Markdown message covering its nearest relatively positioned parent, e.g. when the content below is masked.
 * Styled like CModal, with tighter padding and no close button.
 * Collapses after wordLength words, like the collapsible CLocalizedText.
 */
export default function COverlayMessage(props: Props) {
  const [isExpanded, setIsExpanded] = useState(false);

  const words = props.message.mdText.split(' ');
  const isCollapsible = words.length > props.message.wordLength;

  const collapsedText = props.message.mdText.includes('<br/>')
    ? props.message.mdText.split('<br/>')[0]
    : words.slice(0, props.message.wordLength).join(' ');

  return (
    <div
      className={
        'absolute inset-0 z-10 flex items-center justify-center p-4 sm:px-16 bg-white bg-opacity-50 backdrop-blur-sm'
      }
      onClick={(e) => {
        // Links in the message shouldn't trigger the parent's click, e.g. opening the plot modal
        if ((e.target as HTMLElement).closest('a')) e.stopPropagation();
      }}
    >
      <XDFloatIn>
        <div className={'bg-white shadow-lg rounded-xl p-4 sm:p-6 max-w-xl text-center !text-sm'}>
          {isCollapsible && !isExpanded ? (
            <>
              <CMarkdownText>{collapsedText.replaceAll('**', '')}</CMarkdownText>
              <span>...</span>
              <a
                onClick={() => {
                  setIsExpanded(true);
                }}
              >
                &nbsp;&nbsp;{CLocalizedTextStringStatic('globalReadMore')}
              </a>
            </>
          ) : (
            <>
              <div className={'flex flex-col gap-2'}>
                <CMarkdownText>{props.message.mdText.replaceAll('<br/>', '')}</CMarkdownText>
              </div>
              {isCollapsible && (
                <>
                  <div className={'h-2'} />
                  <a
                    onClick={() => {
                      setIsExpanded(false);
                    }}
                  >
                    {CLocalizedTextStringStatic('globalReadLess')}
                  </a>
                </>
              )}
            </>
          )}
        </div>
      </XDFloatIn>
    </div>
  );
}
